import React from "react";
import VisualDevCard from "./VisualDevCard";

/**
 * Uniform row heights (grid stretch) — tight horizontal gap so pairs sit side-by-side.
 * 2 columns md+ for larger thumbs; 3 columns on xl when there are more projects.
 */
const VisualDevGrid = ({ projects, onProjectActivate }) => {
  if (!projects?.length) return null;

  const colClass =
    projects.length <= 2
      ? "md:grid-cols-2"
      : "md:grid-cols-2 xl:grid-cols-3";

  return (
    <div
      className={`grid grid-cols-1 gap-x-2 gap-y-8 md:gap-x-2 md:gap-y-10 ${colClass} items-stretch`}
    >
      {projects.map((project, index) => (
        <div key={project.id} className="flex min-h-0 h-full min-w-0">
          <VisualDevCard
            project={project}
            index={index}
            onActivate={onProjectActivate}
            className="min-w-0"
          />
        </div>
      ))}
    </div>
  );
};

export default VisualDevGrid;
